module.exports = __webpack_public_path__ + "img/open.fb88a93f.svg";